module.exports = __webpack_public_path__ + "static/img/026_TO8_1518.5107110.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/026_TO8_1518.jpg
// module id = OTKc
// module chunks = 0